exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".extension-component .navigator{margin-bottom:0;bottom:50px;right:10px;background-color:#d8d8d8;opacity:.6;border-top:1px solid #d8d8d8;position:fixed;width:40px;height:40px;border-radius:30px;font-size:20px;line-height:35px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Navigator.scss
// module id = 655
// module chunks = 0